import Dexie from 'dexie';

export const db = new Dexie('KevesLocalDB');

// If another tab opens a newer DB version, close this connection so the upgrade
// can proceed unblocked. The reload picks up the new schema immediately.
db.on('versionchange', () => {
  db.close();
  window.location.reload();
});

// Definimos las tablas y sus índices
// El primer campo es la llave primaria (id)
// Los demás campos con coma son índices para búsquedas rápidas
db.version(1).stores({
  cache: 'key', // Para guardar resultados de Supabase (churches, families, etc)
  outbox: 'id, table, action, timestamp', // Cola de sincronización
  people: 'id, family_id, name',
  families: 'id, church_id, name',
  visits: 'id, district_id, status, date',
  prayers: 'id, district_id, status'
});

// v2: añade índice nextRetryAt en outbox para backoff exponencial.
db.version(2).stores({
  outbox: 'id, table, action, timestamp, nextRetryAt',
});

// v3: tabla notes — módulo offline-first de notas pastorales.
db.version(3).stores({
  notes: 'id, district_id, pinned, archived, dirty, updated_at, updated_locally_at',
});

// v4: expande notes para Pastoral Knowledge System.
// linked_id indexado para consultas rápidas por entidad (person/family/church/event).
// is_reference reemplaza 'pinned' como concepto principal de nota importante.
db.version(4).stores({
  notes: 'id, district_id, dirty, updated_at, updated_locally_at, linked_type, linked_id, is_reference, archived',
});

// v5: módulo predicación — offline-first con sync Supabase vía outbox.
db.version(5).stores({
  preaching_rosters:     'id, district_id, status',
  preaching_assignments: 'id, roster_id, church_id, date, [roster_id+church_id]',
});

// v6: notificaciones locales — reminders generados desde visitas/eventos/oraciones.
db.version(6).stores({
  notifications: 'id, district_id, type, read, created_at',
});

// v7: módulo Materials — materiales, movimientos, préstamos.
// category_id indexado para filtros por categoría.
// loan_id en movements para queries de historial de préstamo.
db.version(7).stores({
  materials:          'id, district_id, category_id, name, deleted_at',
  material_movements: 'id, material_id, district_id, movement_type, created_at',
  material_loans:     'id, material_id, district_id, status, loan_date, deleted_at',
});

// v8: scope + district_id indexes on people (scope column kept for RLS; district_role managed via DistrictTeam).
db.version(8).stores({
  people: 'id, family_id, name, district_id, scope',
});

// v9: horario del pastor — tabla reservada, sin implementación aún.
// features/schedule/hooks/ está vacío. No hay funciones de API ni componentes
// que lean o escriban esta tabla. Mantener el store para no romper la cadena
// de versiones de Dexie — eliminarlo requeriría migración destructiva.
// TODO: implementar módulo completo de horario pastoral antes de usar esta tabla.
db.version(9).stores({
  pastor_schedule: 'id, district_id, date, type, status',
});

// v10: gastos del distrito — bounded context aislado de materiales y remesas.
db.version(10).stores({
  district_expenses:         'id, district_id, expense_date',
  district_expense_churches: 'id, expense_id, church_id, status',
});

// v11: añade church_id al índice de prayers para búsquedas por iglesia.
db.version(11).stores({
  prayers: 'id, district_id, church_id, status',
});

// v12: planificador de sermones del pastor — solo caché local de IDs para invalidación.
db.version(12).stores({
  sermon_plans: 'id, district_id, status, sermon_date',
});

export const clearLocalData = async () => {
  await Promise.allSettled([
    db.cache.clear(),
    db.outbox.clear(),
    db.notes.clear(),
    db.people.clear(),
    db.families.clear(),
    db.visits.clear(),
    db.prayers.clear(),
    db.preaching_rosters.clear(),
    db.preaching_assignments.clear(),
    db.materials.clear(),
    db.material_movements.clear(),
    db.material_loans.clear(),
    db.notifications.clear(),
    db.pastor_schedule.clear(),
    db.district_expenses.clear(),
    db.district_expense_churches.clear(),
    db.sermon_plans.clear(),
  ]);
};